const items = [
    "Lead Scoring", "Automated Workflows", "Omnichannel Outreach",
    "Visual Pipelines", "Field Route Tracking", "Custom Reports",
    "WhatsApp Campaigns", "Email Sequences", "Deal Insights",
];

const Row = () => (
    <div className="flex shrink-0 items-center">
        {items.map((t) => (
            <span key={t} className="flex items-center">
                <span className="mx-8 font-display text-2xl font-bold tracking-tight text-[#111827]/90 sm:text-3xl">
                    {t}
                </span>
                <span className="h-2 w-2 rounded-full bg-[#16A34A]" />
            </span>
        ))}
    </div>
);

const Marquee = () => (
    <section
        data-testid="editorial-marquee-container"
        aria-hidden="true"
        className="overflow-hidden border-y border-[#F1F5F9] bg-[#F7FEF9] py-8"
    >
        <div className="mask-fade-x flex w-max animate-marquee">
            <Row />
            <Row />
        </div>
    </section>
);

export default Marquee;
